import { FieldGroup, TextBox } from '@idexx-laboratories/spot-react';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useStore } from '../../hooks/use-store';
import './VerificationCodeModalContent.scss';
import { MAX_VERIFICATION_CODE_ATTEMPTS } from './VerificationCodeModalContentStore';

const VERIFICATION_CODE_LENGTH = 6;

const VerificationCodeModalContent = observer(() => {
  const { verificationCodeModalContentStore: store, globalStore } = useStore();
  const { attemptsLeft, errorText } = store;
  const [verificationCode, setVerificationCode] = useState<string>('');

  const modalProps = globalStore.globalModalProps;

  useEffect(() => store.init(), [store]);

  useEffect(() => {
    runInAction(() => {
      modalProps.onCancel = () => store.resendCode();
      modalProps.onExit = () => store.closeModal();
      modalProps.exitOkAction = undefined;
      modalProps.onOk = () => store.submitCode(verificationCode);
    });
  }, [modalProps, store, verificationCode]);

  useEffect(() => {
    runInAction(
      () =>
        (modalProps.okDisabled =
          verificationCode.length !== VERIFICATION_CODE_LENGTH || attemptsLeft === 0),
    );
  }, [attemptsLeft, modalProps, verificationCode.length]);

  useEffect(() => {
    if (attemptsLeft === MAX_VERIFICATION_CODE_ATTEMPTS) setVerificationCode('');
  }, [attemptsLeft]);

  const onChange = (newValue: string) => {
    if (/^\d{0,6}$/.test(newValue)) setVerificationCode(newValue);
  };

  return (
    <div className='verification-code-content_container'>
      <p>Please enter the code from your Cornerstone server.</p>
      <p>
        Click <strong>Resend Code</strong> to end a new code if it has expired or was entered
        incorrectly 3 times.
      </p>
      <FieldGroup errorText={errorText}>
        <TextBox
          className='verification-code-text-box'
          placeholder='Enter code and click Submit'
          data-testid='verification-code-input'
          disabled={modalProps.disabled}
          value={verificationCode}
          onChange={e => onChange(e.target.value)}
        />
      </FieldGroup>
    </div>
  );
});

export default VerificationCodeModalContent;
